/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  a,
  BoxC,
  IptC,
  LblC,
  SrlC,
  GridC,
  _cv_60___Ci,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as SrlC from "./_ccbSrlC";
import * as GridC from "./_cccGridC";
import * as LblC from "./_cccLblC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as _cv_10___Mz from "./_cv_10___Mz";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as _cv_40___Mz from "./_cv_40___Mz";
import * as _cv_51___Mz from "./_cv_51___Mz";
import * as _cv_60___Ci from "./_cv_60___Ci";
import * as _cv_60___Mz from "./_cv_60___Mz";
import * as _cv_60___Ti from "./_cv_60___Ti";
import * as _cv_61___Ci from "./_cv_61___Ci";
import * as _cv_61___Mz from "./_cv_61___Mz";
import * as _cv_61___Ti from "./_cv_61___Ti";
import * as _cv_70___Ci from "./_cv_70___Ci";
import * as _cv_70___Ti from "./_cv_70___Ti";
import * as ht from './_ht';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  return (
    cr.c(BoxC.N, {
      key: -10,
      abtType: 'bdyCmnz',
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'barFtnOrnz',
          boxStlz: a(`mb/2`),
          lineCs: [{
            cellCs: [
              {
                oClds: [
                ]
              },
              {
                oClds: [
                  cr.c(LblC.N, {
                    key: -10,
                    abtType: 'ftnCmnz',
                    boxStlz: a('dw/23'),
                    lblCz: {
                      boxStlz: a('dw/8'),
                      textz: {
                        pfx: '変更履歴',
                      }
                    },
                    cttCz: {
                      oClds: [
                        cr.c(IptC.S, {
                          key: -10,
                          abtType: 'ftnCmnz',
                          cz: {
                            bEdit: true,
                            iptType: 'pcr',
                            ls: [],
                          },
                        })
                      ]
                    },
                  })
                ]
              }
            ]
          }]
        }),

        cr.c(BoxC.N, {
          key: -20,
          abtType: 'cttCmnz',
          oClds: [

/*
            cr.c(MsgC.N, {
              key: -10,
              abtType: 'cttCmnz',
              boxStlz: a('mb/2'),
              cz: {
                ls: [
                  {
                    mkrCz: {
                      textz: {
                        pfx: _lblz.msgz.cttz.mkr
                      }
                    },
                    msgCz: {
                      textz: {
                        pfx: _lblz.msgz.cttz.msg
                      }
                    }
                  },
                ]
              },
            }),
*/

            cr.c(SrlC.V, {
              key: -20,
              srlStlz: {
                otrz: a('dw/f dwx/120 f/1'),
              },
              oClds: [
                cr.c(_cv_60___Ci.D, {
                  key: -20,
                  sPz: pz.sPz,
                  cz: {
                    ccd: 'rd'
                  }
                }),

              ],
            }),

            cr.c(_cv_60___Ci.B, {
              key: -30,
              sPz: pz.sPz,
              cz: {
                lblz: pz.sPz.crt.lblz,
                sc: 'rd7',
              },
            }),

          ]
        })

      ]
    })
  );
};

